<!-- This component displays a list item with a document and further meta data like date read, date updated.  -->
<!-- Details can be displayed by a LONG-CLICK and slide in                                                    -->
<!-- Favorites can be set/unset. An unread item is marked in bold text with an additional badge               -->
<template>
  <div :class="`file-wrapper file-wrapper-${themeName} ${isSelected ? 'selected-' + themeName : ''}`"
       @click="onItemSelected"
       :style="`border-bottom:1px solid #${darkMode ? '101010' : 'd0d0d0'} !important`">

    <div class="op-left"
         @click.stop.prevent="">

      <!-- Item with teaserUrl on left -->
      <div v-if="teaserUrl"
           class="elevation-1 news-teaser"
           :style="`background:URL(${teaserUrl})`"></div>

      <!-- badge with counter -->
      <v-badge v-else-if="hasCounterBadge"
               class="left-icon"
               :dark="darkMode"
               :color="badgeColor"
               :content="badgeNumber"
               overlap
               offset-x="26"
               offset-y="21">
        <v-icon v-if="!avatarUrl"
                :color="iconColor">{{ itemIcon }}
        </v-icon>
        <v-avatar v-else
                  size="35"
                  :color="theme.avatarBg"
                  class="mr-2 mt-2 avatar-img"
                  @click.stop="$emit('onAvatarClick')">
          <img :src="avatarUrl"/>
        </v-avatar>
      </v-badge>

      <v-badge v-else-if="hasDotBadge && badgeIcon"
               class="left-icon"
               :color="badgeColor"
               :icon="badgeIcon"
               overlap
               offset-x="24"
               offset-y="22">
        <v-icon v-if="!avatarUrl"
                :color="iconColor">{{ itemIcon }}
        </v-icon>
        <v-avatar v-else
                  size="35"
                  :color="theme.avatarBg"
                  class="mr-2 mt-2 avatar-img"
                  @click.stop="$emit('onAvatarClick')">
          <img :src="avatarUrl"/>
        </v-avatar>
      </v-badge>

      <v-badge v-else-if="hasDotBadge"
               class="left-icon"
               :color="badgeColor"
               overlap
               offset-x="20"
               offset-y="14"
               dot>
        <v-icon v-if="!avatarUrl"
                :color="iconColor">{{ itemIcon }}
        </v-icon>
        <v-avatar v-else
                  size="35"
                  :color="theme.avatarBg"
                  class="mr-2 mt-2 avatar-img"
                  @click.stop="$emit('onAvatarClick')">
          <img :src="avatarUrl"/>
        </v-avatar>
      </v-badge>

      <v-icon v-else-if="!avatarUrl"
              :color="iconColor"
              class="left-icon">{{ itemIcon }}
      </v-icon>
      <v-avatar v-else
                size="35"
                :color="theme.avatarBg"
                class="mr-2 mt-2 avatar-img"
                @click.stop="$emit('onAvatarClick')">
        <img :src="avatarUrl"/>
      </v-avatar>

    </div>

    <div class="op-content"
         v-longpress.stop.prevent="toggleSlideOver">
      <div class="op-content-title"
           :class="isUnread?'font-weight-black':''">{{ title }}
        <!-- <div class="subtitle-2"
             :class="isUnread?'font-weight-black':''">{{title}}</div> -->

      </div>
      <div class="op-content-inner">
        <slot name="content"></slot>
      </div>
    </div>
    <div class="op-right">
      <slot name="right-column"></slot>
    </div>

    <div v-if="$slots['slide-over']"
         class="expansion d-flex flex-column align-start px-3 py-2 my-0 accent"
         :class="`expander ${isExpanded ? 'accent' : 'transparent'}`"
         :style="`transform:${isExpanded ? 'translateX(0%)':'translateX(-200%)'}`"
         @click.stop.prevent="collapseSlideOver">

      <slot name="slide-over"></slot>

    </div>
  </div>
</template>

<script>

import common from '@/mixins/common';

let collapseTime;
export default {
  name: 'ListItem',
  mixins: [common],
  components: {},

  props: {
    title: String,
    itemIcon: String,
    hasDotBadge: {type: Boolean, default: false},
    displayZeroBadge: {type: Boolean, default: false},
    teaserUrl: {type: String, required: false},
    badgeNumber: Number,
    badgeColor: String,
    iconColor: String,
    badgeIcon: String,
    longClickEnabled: {type: Boolean, default: true},
    file: Object,
    avatarUrl: String,

    isSelected: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      filter: '',
      isLongPress: false,
      isExpanded: false,
      expandedContentIsVisible: false,
    };
  },
  computed: {
    hasCounterBadge() {
      return this.badgeNumber && (this.badgeNumber > 0 || this.displayZeroBadge);
    },

    isUnread() {
      return this.hasDotBadge;
    },
  },
  methods: {
    onItemSelected() {
      // long press comes before click and if so, the isLongPress flag needs to be cleared to be ready for the next real click
      if (!this.isLongPress) {
        this.$emit('onItemSelected', this.item);
      } else {
        this.isLongPress = false;
      }
    },
    collapseSlideOver() {
      this.isExpanded = false;
      collapseTime = Date.now();
    },
    toggleSlideOver() {
      let now = Date.now();
      let timeSinceLastCollapse = now - (collapseTime ? collapseTime : 0);

      if (this.longClickEnabled && timeSinceLastCollapse > 2000) {
        this.isLongPress = true;
        this.isExpanded = true;
      }
    },
  },
};
</script>

<style scoped>


.left-icon {
  display: flex !important;
  flex-direction: row;
  justify-content: center !important;
  width: 100%;
  align-content: center !important;
  padding-top: 8px;
}

/* NO SELECTION + HIGHLIGHT COLOR ==> avoids copy/paste functions which is inappropriate on smart phones*/
* {
  user-select: none;
}

*::selection {
  background: none;
}

*::-moz-selection {
  background: none;
}


.file-wrapper-dark,
.file-wrapper-light {
  position: relative;
  transition: 0.5s;
  height: 90px;
  width: 100%;
  /* border: 1px solid red; */
}

.file-wrapper-light:hover {
  background: #d5d5d5 !important;
  transform: translateX(2px);
  z-index: 1000;
  opacity: 1;
}

.file-wrapper-dark:hover {
  /* .file-wrapper-dark > *:hover,
.file-wrapper-dark > .file > *:hover { */
  background: #303030 !important;
  transform: translateX(2px);
  z-index: 1000;
  opacity: 1;
}

.selected-dark {
  background: #101010 !important;
}

.selected-light {
  background: #d0d0d0 !important;
}

/* .file-title { */
/* font-size: 13px !important; */
/* } */
.expander {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1002 !important;
  overflow: hidden;
  display: flex;
  /* margin-top: -80px; */
  transform: translateX(-90%);
  transition: all 300ms ease-in;
}

.news-teaser {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-size: cover !important;
  background-position: center !important;
  overflow: hidden;
  /* border: 1px solid purple; */
  border-radius: 3px;
}

.avatar-img:hover {
  cursor: pointer;
}

.avatar-img {
  margin-left: 8px;
}
</style>
